<template>
  <div class="main">
    <div class="details">
      <div class="result line_bottom">
        <div class="title">
          <div>{{title}}</div>
        </div>
        <div class="auditResults">审核结果：{{taskDetailsData.handleResult}}</div>
      </div>
      <div class="toBeEdited">
        <div class="specificContent">
          <div class="title">审核意见</div>
          <div class="content">{{taskDetailsData.memo}}</div>
        </div>
        <div class="missionName">
          <div class="title">任务名称</div>
          <span class="theme">{{taskDetailsData.name}}</span>
        </div>
        <div class="seeDetails">
          <span @click="goTaskDetail">查看任务详情</span>
          <img src="../../../../assets/image/tb-right.png" alt />
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="status" @click="changeBtn" v-show='!taskDetailsData.isHandle'>我知道了</div>
      <div class="status saw"   v-show='taskDetailsData.isHandle'>已知悉</div>
    </div>
  </div>
</template>
<script>
    import api from '../../../../service/modules/integrity';
    import apimessage from '../../../../service/modules/message'
    export default {
        data () {
            return {
                title: '评分任务待编辑',
                // auditResults: '',
                format: {},
                taskId: '',
                id: '',
                taskDetailsData: {} // 详情页
            };
        },
        created () {
            let messageId = this.$route.query.messageId || ''
            let isRead = this.$route.query.isRead || 'true'
            this.onMessageReadOne(isRead, messageId)

            this.taskId = this.$route.query.taskId;
            this.id = this.$route.query.id;
            this.handleList();
        },
        methods: {
            // 消息单条已读
            onMessageReadOne (isRead, id) {
                if (isRead === 'false') {
                    apimessage.messageReadOne({ messageId: id }).then(res => {
                        localStorage.setItem('messageId', id)
                    })
                }
            },
            changeBtn () {
                api.taskKnow({ id: this.id }).then(res => {
                    if (res.ret === 0) {
                        this.$toast('该条待办已标记为完成')
                        this.taskDetailsData.isHandle = !this.taskDetailsData.isHandle
                    }
                });
            },
            handleList () {
                let parm = {
                    id: this.id
                };
                api.taskDetails(parm).then(res => {
                    // console.log(10000, res)
                    if (res.ret === 0) {
                        this.taskDetailsData = res.data;
                    }
                });
            },
            // 跳转至企业详情 带企业id传参
            // 评分任务的查看详情
            goTaskDetail () {
                this.$router.push({
                    path: 'auditFailed',
                    query: {
                        taskId: this.taskDetailsData.taskId,
                        id: this.taskDetailsData.id
                    }
                });
            }
        }
    };
</script>
<style lang="less" scoped>
.main {
  color: #333;
  width: 100%;
  min-height: 100%;
  background-color: #fbfbfb;
  padding: 21px 12px 84px 12px;
  box-sizing: border-box;
  .details {
    width: 100%;
    background-color: #fff;
    float: left;
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    .result {
      width: 100%;
      padding: 16px;
      min-height: 72px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        font-size: 16px;
        font-weight: 600;
      }
      .auditResults {
        font-size: 14px;
        font-weight: 600;
        color: #ff8c19;
        margin-top: 12px;
      }
    }
    .specificContent {
      width: 100%;
      padding: 16px 16px 0 16px;
      .title {
        font-weight: 400;
        font-size: 14px;
        color: #999;
      }
      .content {
        margin-top: 8px;
        font-size: 14px;
        color: #333;
        font-weight: 400;
        line-height: 22px;
      }
    }
    .missionName {
      padding: 16px 16px 12px 16px;
      margin-top: 5px;
      .title {
        font-size: 14px;
        font-weight: 400;
        color: #999;
      }
      .theme {
        display: inline-block;
        font-size: 14px;
        line-height: 16px;
        font-weight: 400;
        margin-top: 12px;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .seeDetails {
      padding: 0 16px 18px 16px;
      color: #36b374;
      font-size: 12px;
      font-weight: 400;
      float: left;
      span {
        float: left;
      }
      img {
        float: left;
        display: inline-block;
        width: 12px;
        height: 12px;
      }
    }
    .toBeRectified {
      width: 100%;
      .companyName,
      .jurisdiction,
      .supervisionDate {
        height: 60px;
        width: 100%;
        line-height: 60px;
        padding: 0 16px;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #eee;
        .left {
          color: #999;
        }
      }
      .companyName {
        .right {
          span {
            float: left;
          }
          img {
            display: inline-block;
            float: right;
            width: 12px;
            height: 12px;
            margin-top: 24px;
          }
        }
      }
      .integrityIndex {
        height: 60px;
        width: 100%;
        line-height: 60px;
        padding: 0 16px;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #eee;
        .className {
          color: #333;
          font-size: 14px;
          font-weight: 500;
        }
        .num {
          display: inline-block;
          margin-left: 12px;
          color: #ff4d4d;
          font-size: 20px;
          font-weight: bold;
        }
        .unit {
          color: #ff4d4d;
          font-size: 12px;
          -webkit-transform: scale(0.84);
        }
        .right {
          span {
            float: left;
          }
          img {
            display: inline-block;
            float: right;
            width: 12px;
            height: 12px;
            margin-top: 24px;
          }
        }
      }
    }
  }
  .bottom {
    width: 100%;
    height: 74px;
    background-color: #fff;
    padding: 12px;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    .status {
      width: 100%;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background-color: #36b374;
      color: #fff;
      font-size: 16px;
      font-weight: 600;
    }
    .saw {
      opacity: 0.5;
    }
  }
}
</style>
